var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 64.3213,
    height: 118.706,
    viewBox: "0 0 64.3213 118.706",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008670",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34625692",
    filter: "url(#filter0_f_0_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95422 7.51693L16.1152 6.88729L20.7177 110.401L12.9267 116.752L1.95422 7.51693Z",
    fill: "url(#paint0_linear_0_47)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34625694",
    filter: "url(#filter1_f_0_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3671 5.2108L39.2829 1.95422L24.8088 104.554L37.1054 112.347L62.3671 5.2108Z",
    fill: "url(#paint1_linear_0_47)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34625693",
    filter: "url(#filter2_f_0_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3867 7.69536L33.2924 7.69536L29.4709 111.311L16.3867 109.675V7.69536Z",
    fill: "url(#paint2_linear_0_47)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_47",
    x: 3.12284e-8,
    y: 4.93308,
    width: 22.6719,
    height: 113.773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977108,
    result: "effect1_foregroundBlur_0_47"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_47",
    x: 22.8545,
    y: -2.22281e-8,
    width: 41.4668,
    height: 114.301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977108,
    result: "effect1_foregroundBlur_0_47"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_47",
    x: 14.4325,
    y: 5.74114,
    width: 20.8141,
    height: 107.524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977108,
    result: "effect1_foregroundBlur_0_47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_47",
    x1: 6.256,
    y1: 40.8782,
    x2: 28.5793,
    y2: 127.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD18",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_47",
    x1: 45.5198,
    y1: 7.72493,
    x2: 22.3198,
    y2: 122.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD18",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_47",
    x1: 23.2043,
    y1: 20.8881,
    x2: 36.5645,
    y2: 128.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD18",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.d02dbf856cdd61857bc4c97c9964fb7f.svg";
export { ForwardRef as ReactComponent };